import React from "react";
import { useNavigate } from "react-router-dom";

import logo from "../../assets/logo.png";
import "./InventoriesMenu.scss";
import InventoryButton from "../inventories/InventoryButton/InventoryButton";
import {
  faLayerGroup,
  faTags,
  faInbox,
} from "@fortawesome/free-solid-svg-icons";

import { Container, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const InventoriesMenu: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container className="px-4 px-md-5">
      <Row className="align-items-center mb-1 mt-1">
        <Col className="text-center mt-1">
          <img src={logo} alt="Logo" style={{ width: "175px" }} />
        </Col>
      </Row>
      <Row className="align-items-center mb-4 mt-1">
        <Col className="text-center mt-1">
          <h2 className="fw-bold">Inventario</h2>
        </Col>
      </Row>
      <Row className="align-items-center mb-4 mt-1">
        <Col className="text-center mt-3">
          <h3 className="fw-bold">Selecciona una opción para ver su listado</h3>
        </Col>
      </Row>
      <Row className="align-items-center ">
        <Col />
        <Col className="text-center mt-3">
          <InventoryButton
            onClick={() => navigate("/inventories/categories")}
            text="Categorías"
            icon={
              <FontAwesomeIcon className="icon_inventory" icon={faLayerGroup} />
            }
          />
        </Col>
        <Col className="text-center mt-3">
          <InventoryButton
            onClick={() => navigate("/inventories/products")}
            text="Productos"
            icon={<FontAwesomeIcon className="icon_inventory" icon={faInbox} />}
          />
        </Col>
        <Col />
      </Row>
      <Row className="align-items-center mb-4 mt-1">
        <Col className="text-center mt-3">
          <InventoryButton
            onClick={() => navigate("/inventories/sizes")}
            text="Tallas"
            icon={<FontAwesomeIcon className="icon_inventory" icon={faTags} />}
          />
        </Col>
      </Row>
    </Container>
  );
};
export default InventoriesMenu;
